export const UPLOAD_GET_ALL_FILES = "UPLOAD_GET_ALL_FILES";
export const UPLOAD_DELETE_FILE = "UPLOAD_DELETE_FILE";
export const UPLOAD_SEARCH_FILE = "UPLOAD_SEARCH_FILE";
export const UPLOAD_SEARCH_FILE_BY_TYPE = "UPLOAD_SEARCH_FILE_BY_TYPE";
export const UPLOAD_UPDATE_FILE = "UPLOAD_UPDATE_FILE";
export const UPLOAD_SAVE_UPLOADED_FILE = "UPLOAD_SAVE_UPLOADED_FILE";
export const UPLOAD_TO_BUNNY_CDN = "UPLOAD_TO_BUNNY_CDN";